<template>
    <div class="product-accordion-container">
        <accordion :items="products" :class="color">
            <template v-slot:accordion-selector-title="{item}">
                <span class="title" v-html="item.post_title"></span>
            </template>
            <template v-slot:accordion-item-header-title="{item, itemIndex}">
                <div class="title with-icon">
                    <slot :name="'product-icon-'+itemIndex"></slot>
                    <span class="text" v-html="item.post_title"></span>
                </div>
            </template>
            <template v-slot:accordion-item-content="{item, itemIndex}">
                <div class="container">
                    <highlight-item :options="getHighlightOptions(item)">
                        <template v-slot:custom-column>
                            <div class="col case-study-container">
                                <slot :name="'custom-column-'+itemIndex"></slot>
                            </div>
                        </template>
                    </highlight-item>
                </div>
            </template>
        </accordion>
    </div>
</template>

<script>
export default {
    props: {
        products: {
            type: Array,
            required: true
        },
        color: {
            type: String,
            default: "blue"
        }
    },
    mounted() {},
    methods: {
        getHighlightOptions(item) {
            var acfFields = item.acf_fields;
            return {
                'primary_image': acfFields.product_image,
                'content': {
                    'top_title': "Product",
                    'title': item.post_title,
                    'description': acfFields.feature_settings.product_excerpt,
                    'button': {
                        'url': item.permalink,
                        'title': "View more details"
                    },
                },
                //'secondary_images': [acfFields.feature_settings.secondary_image_1, acfFields.feature_settings.secondary_image_2]
                'secondary_images': false
            }
        }
    }
}
</script>